"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCalloutCharge = void 0;
var isCalloutCharge = function (itemSku) {
    return itemSku.includes("CALLOUT");
};
exports.isCalloutCharge = isCalloutCharge;
